
import { CNavItem, CNavTitle } from '@coreui/react'
import { t } from 'i18next'

const NavRoutes = [
  {
    component: CNavItem,
    name: t('title.home'),
    to: '/',
    // icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: t('title.applications'),
  },
  {
    component: CNavItem,
    name: t('card.title_first_card'),
    to: 'new-app',
    
  },
  {
    component: CNavItem,
    name: t('card.title_second_card'),
    to: 'apps',
    
  },
  // {
  //   component: CNavItem,
  //   name: t('card.title_third_card'),
  //   to: 'analytics',
    
  // },
  {
    component: CNavItem,
    name: t('card.prices_plans'),
    to: 'prices-plans',
  },
]

export default NavRoutes
